<template>
  <div class="d-flex flex-column align-center justify-center radio-group-box">
    <div v-if="questionText" class="question-text">
      {{ questionText }}
    </div>
    <v-radio-group
      v-model="answerId"
      :row="question.optionsDirection === 'row'"
      :column="question.optionsDirection === 'column'"
      dense
      hide-details
      class="mt-0 d-flex flex-column"
      @change="selectAnswer"
    >
      <v-radio
        v-for="(option, index) in items"
        :key="option.id"
        :value="option.id"
        :class="{
          'dense': !!option.imageName,
          'mr-0': (index % 2 !== 0 && !option.imageName) || index === items.length - 1
        }"
        active-class="selected-option"
        class="radio-input mb-1"
      >
        <template #label>
          <div
            class="d-flex flex-column align-center justify-center"
            :style="{width: !!option.imageName ? '100%' : 'auto'}"
          >
            <v-img
              v-if="!!option.imageName"
              :src="option.imageName"
              :width="isMobile ? 50 : 75"
              aspect-ratio="1.5"
              contain
              class="mb-2"
            />
            <div class="option-label-custom">
              {{ option.text }}<template v-if="option.roadTaxAmount">:
                <span style="font-weight: 600;">{{ option.roadTaxAmount }} MDL</span>
              </template>
            </div>
          </div>
        </template>
      </v-radio>
    </v-radio-group>
  </div>
</template>

<script>
import { roadTax } from '@/_utils/static-data';

export default {
  name: 'RadioQuestion',
  props: {
    question: {
      type: Object,
      required: true
    },
    parentAnswer: {
      type: Object,
      default: null
    },
    currentAnswer: {
      type: Object,
      default: null
    },
    answers: {
      type: Array,
      default: () => []
    },
    roadTaxType: {
      type: Number,
      default: 0
    },
    exchangeRate: {
      type: String,
      default: '20.6'
    }
  },
  data() {
    return {
      answerId: null
    };
  },
  computed: {
    items() {
      let options = [...this.question.options];
      if (this.parentAnswer && this.question.filterable) {
        options = options.filter(el => el.parentId === this.parentAnswer.id || !el.parentId);
      }
      options = options.filter((option) => {
        if (option.visibleIf) {
          const dependantAnswer = this.answers.find(el => el.questionId === option.visibleIf.questionId);
          if (dependantAnswer?.id !== option.visibleIf.answer) {
            return false;
          }
        }
        return true;
      });
      // SPECIAL CASE: DYNAMIC OPTION VALUE
      if (this.question?.id === 6 && this.roadTaxType) {
        options = options
          .filter((item) => {
            return !(item.id === 1 && (this.roadTaxType === 1 || this.roadTaxType === 2));
          }).map((el) => {
            el.roadTaxAmount = this.getRoadTaxAmount(el.roadTaxValue);
            return el;
          });
      }
      return options;
    },
    isMobile() {
      return this.$vuetify.breakpoint.width < 961;
    },
    questionText() {
      if (this.question?.parent === this.parentAnswer?.questionId && this.question.filterableText) {
        return this.question.filterableText.find(el => el.parentId === this.parentAnswer.id)?.text;
      }
      return this.question.text;
    }
  },
  watch: {
    parentAnswer() {
      this.answerId = null;
    }
  },
  mounted() {
    this.answerId = this.currentAnswer ? this.currentAnswer.id : null;
  },
  methods: {
    selectAnswer() {
      const selected = this.question.options.find(el => el.id === this.answerId);
      selected.questionId = this.question.id;
      selected.questionText = this.question.text;
      selected.isBonus = this.question.isBonus || false;
      this.$emit('selectAnswer', selected);
    },
    getRoadTaxAmount(optionId) {
      const adjustedChangeRate = parseFloat(this.exchangeRate) + 1.8;
      return (optionId && this.roadTaxType)
        ? parseFloat(roadTax[this.roadTaxType - 1][optionId - 1] * adjustedChangeRate).toFixed(2)
        : null;
    }
  }
};
</script>

<style scoped>
.question-text {
  font-size: 14px;
  font-weight: 500;
  text-align: center;
}
.radio-group-box {
  width: 355px;
}
.radio-group-box ::v-deep .v-input--radio-group__input {
  justify-content: center;
}
@media screen and (max-width: 600px) {
  .radio-group-box {
    width: 260px !important;
  }
}
.radio-input ::v-deep label {
  margin-bottom: 0 !important;
  padding: 4px 0;
}
.radio-input {
  padding: 2px 12px;
  min-width: 157px !important;
  border-radius: 4px;
  border: 1px solid #df0100;
}
.radio-input.dense {
  min-width: 100px !important;
}
.radio-input ::v-deep .v-input--selection-controls__input {
  display: none;
}
@media screen and (max-width: 600px) {
  .radio-input {
    min-width: 120px !important;
  }
  .radio-input.dense {
    padding: 2px 2px;
    font-size: 12px;
    min-width: 75px !important;
  }
  .option-label-custom {
    font-size: 14px;
  }
}
.selected-option {
  background-color: #df0100;
}
.selected-option ::v-deep label {
  color: #FFFFFF !important;
}
</style>
